import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from 'react-moment';
import ReactLoading from 'react-loading';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Form, Button, ProgressBar, ModalFooter } from "react-bootstrap"
import TablePagination from '@mui/material/TablePagination';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import '../../components/loader.css';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'

const Cod_mismatch = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const[modalstate , setmodalstate] = React.useState(false)
    const [uploadModalState, setUploadModalState] = useState({ show: false,excel_fle:"" });
    const[isloading , setisloading]= React.useState(false)
    const [otherStates,setOtherState] = React.useState({activePage:1,rowsPerPage:10,page:0,total_count:0,onload:true});
    const[state , setState] = React.useState([])
    const[searchstate , setsearchstate] = React.useState({find:""})
 const toggleSidebar = () => {
     setIsSidebarOpen(!isSidebarOpen);
     const homeSection = document.querySelector('.home-section');
     if (homeSection) {
         homeSection.classList.toggle('sidebar-closed');
     }
 };

 const closeModal = ()=>{
    setmodalstate(false)
   }

   const csvinputEditHandleChange = (e) => {        
    if (e.target.type == "file") {            
        setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.files });
    } else {
        setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.value });
    }
  }

  const uploadPincodeFile= () => {
    setisloading(true)
    if (uploadModalState.excel_fle != undefined && uploadModalState.excel_fle != '') {
        let fileName = uploadModalState.excel_fle[0].name;
        if(fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0] == ".csv"){
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/upload_cod_mismatch_file`;
     let bodyFormData = new FormData()
     bodyFormData.append("excel_fle", uploadModalState.excel_fle[0]);
     console.log("bb", bodyFormData);
    axios.post(full_api, bodyFormData, {
        headers:exportValue.headers
    }).then((res) => {
        console.log("res ", res);
       setUploadModalState({...uploadModalState, show: false });
       if (res.data.status == true) {
            const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
        })
            Toast.fire({
                background: "#206bc4",
                type: 'success',
                title: res.data.message,
                color: "white"
            });
            setisloading(false)
            axios_get_api(otherStates.page,true)
          }
        
        else {
            
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: res.data.message,

            })
            setisloading(false)
            axios_get_api(otherStates.page,true)
        }
      }).catch((e) => {

        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',

        })
        setisloading(false)
        axios_get_api(otherStates.page,true)
    });
}else {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
})
    Toast.fire({
        background: "#8a2be2",
        type: 'error',
        title: "Please choose CSV file!",
        color: "white"
    });
    setisloading(false)
    
}
}else {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000
})
         Toast.fire({
                background: "#10b93b",
                type: 'error',
                title: "Please choose a file!",
                color: "white"
            });
            setisloading(false)
}
}

React.useEffect(()=>{
    axios_get_api(0,true)
},[])


const axios_get_api = (index = 0, onLoad) => {

  
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/cod_mismatch_list`;
    let sendData = { dstatus: otherStates.dstatus, limit: otherStates.rowsPerPage, indexValue: index };

    if (searchstate.find!="") {
        sendData.find = searchstate.find
    }
    
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
       
        console.log("response ", res);
        console.log("otherStates ", otherStates);
        if (index == 0 && onLoad) {
            setOtherState({ ...otherStates, total_count: res.data.dataCount })
         }
         setState(res.data.output)

      


    }).catch((e) => {
       

    });
}
const handlePageChange = (event,newPage) =>{
    // console.log("newpage",newPage)
    setOtherState({...otherStates,page:newPage})
    //console.log("newPage ", newPage);
    axios_get_api(newPage , true);
    
    // searchUser(state.searchValue,newPage)
}
const handleChangeRowsPerPage = (event,newPage) => {
    // console.log("event ", event);
    setOtherState({...otherStates, rowsPerPage:+event.target.value, page:0})
   
}
const handleChange = (event) => {
    // console.log("event ", event);
    setsearchstate({...searchstate, find:event.target.value})
   
}


  return (
    <div>
       <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               
       <Sub_header/> 
       <Modal show={modalstate} onHide={() =>closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>COD Mismatch</Modal.Title>
                </Modal.Header>
                <Modal.Body>
          
                <div class="modal-body">
        <div class="d-flex justify-content-between">
            <div class="">Download Sample File</div>
            <div class="ps-2 "><a href="./assets/doc/Cod_mismatch.csv" target="_blank"  class="btn btn-outline-primary btn-sm">Downlaod Sample File</a></div>
        </div>
        <hr/>
    
        <div class="mb-3 mt-3">
          <label for="" class="form-label">File: <span class="text-danger">*</span></label>
          <input type="file" class="form-control" id="" placeholder="Enter Banner" name="excel_fle" onChange={(e) => csvinputEditHandleChange(e)}/>
        </div>
      </div>
<div class="modal-footer">
{isloading? <ReactLoading type={"spin"} color={"#000000"} height={30} width={30} />:
        <button type="button" class="btn btn-primary"  onClick={() =>uploadPincodeFile()}>Submit</button>}
      </div>
           </Modal.Body>
</Modal>
       <section class="mt-3">
        <div class="row mb-3">
            <div class="col-12 col-md-3">
                <h5>COD Mismatch Managment</h5>
            </div>
            <div class="col-12 col-md">
                <div class="row">
                    <div class="col-12 col-md">
                        <div class="input-group me-2 me-lg-3 fmxw-400">
                            <select class="form-select">
                              <option>AWB #</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Search AWB Number" onChange={(e)=>handleChange(e)}/>
                            <span class="input-group-text ">
                                <svg class="icon icon-xs" x-description="Heroicon name: solid/search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" onClick={(e)=>axios_get_api(otherStates.page,true)}>
                                    <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 text-end">
                        <a href="#" class="btn btn-primary" onClick={()=>setmodalstate(true)}>Upload COD Payments</a>
                    </div>
                </div>
            </div>
        </div>

        

        


            <div class="card card-body border-0 shadow table-wrapper table-responsive ">
                <table class="table table-hover  shipm_tablew">
                    <thead>
                        <tr>
                            <th class="border-gray-200">AWB #</th>	
                            <th class="border-gray-200">Carrier</th>
                            <th class="border-gray-200">Product </th>
                            <th class="border-gray-200">Customer Amount</th>
                            <th class="border-gray-200">Carrier Amount</th>
                            <th class="border-gray-200">Diff. Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                    {state.map((item) => {
  const difference = item.cod_amount - item.cod_mismatch_amount;
  const formattedDifference =
    difference >= 0
      ? `(+ ₹${difference.toFixed(2)})`
      : `(- ₹${Math.abs(difference).toFixed(2)})`;
      const differenceClass = difference >= 0 ? "text-success" : "text-danger";

  return (
    <tr key={item.carrier_tracking_number}>
      <td>
        <h5>
          <a
            href=""
            className="text-info fw-700 fs-6"
          >
            {item.carrier_tracking_number}
          </a>
        </h5>
      </td>
      <td>{item.carrier_name}</td>
      <td>{item.service_provider}</td>
      <td className="text-primary">₹{item.cod_amount}</td>
      <td className="text-info">₹{item.cod_mismatch_amount}</td>
      <td className={`fw-700 ${differenceClass}`}>{formattedDifference}</td>
    </tr>
  );
})}

                       
                    </tbody>
                </table>
                <TablePagination
                            component="div"
                            rowsPerPageOptions={[100,150,200,250]}
                            count={otherStates.total_count}
                            page={otherStates.page}
                            onPageChange={handlePageChange}
                            rowsPerPage={otherStates.rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}

                        />
            </div> 
                    

    </section>
       </section>
    </div>
  )
}

export default Cod_mismatch
